import "@/App.css";
import { useEffect, useRef } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import LandingPage from "./pages/LandingPage";
import { installTelegramClickTracker, trackPageView } from "./lib/pixel";

function PixelRouteTracker() {
  const location = useLocation();
  const isFirstRender = useRef(true);

  useEffect(() => {
    // Install Telegram click delegation once (safe no-op on re-run).
    installTelegramClickTracker();
  }, []);

  useEffect(() => {
    // The base pixel snippet in index.html already fires the initial
    // PageView on page load. We only fire additional PageViews on
    // client-side route changes to support SPA navigation.
    if (isFirstRender.current) {
      isFirstRender.current = false;
      return;
    }
    trackPageView();
  }, [location.pathname, location.search]);

  return null;
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <PixelRouteTracker />
        <Routes>
          <Route path="/" element={<LandingPage />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
